import { form_ds_11 } from "@/data/forms/form-ds-11";
import { form_ds_64 } from "@/data/forms/form-ds-64";
import { form_ds_82 } from "@/data/forms/form-ds-82";
import { form_ds_5504 } from "@/data/forms/form-ds-5504";

export const ds82PdfId = "4cca033e-b25f-4e54-a1fa-a135f94ee699";
export const ds11PdfId = "24e8e7f4-55e0-4a2b-845d-b5a2672b8aa9";
export const ds64PdfId = "8adde866-0a04-4572-b341-3527efb9a314";
export const ds5504PdfId = "e83c32e8-9e8d-4286-bdd4-c3bf72902000";

const formSlugs = [
  {
    name: "DS-11",
    slug: "new-passport",
    alternativeSlugs: ["new"],
    formSchema: form_ds_11,
    pdfId: ds11PdfId,
  },
  {
    name: "DS-64",
    slug: "lost-stolen-passport",
    alternativeSlugs: ["lost-stolen"],
    formSchema: form_ds_64,
    pdfId: ds64PdfId,
  },
  {
    name: "DS-82",
    slug: "passport-renewal",
    alternativeSlugs: ["renewal"],
    formSchema: form_ds_82,
    pdfId: ds82PdfId,
  },
  {
    name: "DS-5504",
    slug: "passport-corrections",
    alternativeSlugs: ["corrections"],
    formSchema: form_ds_5504,
    pdfId: ds5504PdfId,
  },
];

//It Checks if is an accepted slug
export const getContentfulFormSlug = (slug: string) => {
  let contentfulSlug = "form-not-found";
  formSlugs.forEach((form) => {
    if (form.slug === slug || form.alternativeSlugs.includes(slug)) {
      contentfulSlug = form.slug;
    }
  });

  return contentfulSlug;
};

//It return the correspondent form schema
export const getFormSchemaBySlug = (slug: string) => {
  const form = formSlugs.find((form) => form.slug === slug);
  return form?.formSchema ?? null;
};

//It return the correspondent pdf Id
export const getPdfIdBySlug = (slug: string) => {
  const form = formSlugs.find((form) => form.slug === slug);
  return form?.pdfId ?? null;
};

export const getSlugByPdfId = (id: string) => {
  const form = formSlugs.find((form) => form.pdfId === id);
  return form?.slug ?? null;
};

export const getFormNameByPdfId = (id: string) => {
  const form = formSlugs.find((form) => form.pdfId === id);
  return form?.name ?? null;
};
